import React from "react";
import { Avatar } from "antd";
import defaultAvatar from "../img/logoRondNoirPng.png";

const getAvatar = function(item) {
  if ("avatar" in item) {
    if ("_url" in item.avatar) {
      return item.avatar._url;
    } else if ("url" in item.avatar) {
      return item.avatar.url;
    } else {
      return defaultAvatar;
    }
  }
  return defaultAvatar;
};

const getNormalAvatar = function(item) {
  if ("avatar" in item) {
    return <Avatar src={item.avatar.url} />;
  }
  return <Avatar src={defaultAvatar} />;
};

const getLargeAvatar = function(item) {
  if ("avatar" in item) {
    return <Avatar src={item.avatar.url} size="large" />;
  }
  return <Avatar src={defaultAvatar} size="large" />;
};

const getSmallAvatar = function(item) {
  if ("avatar" in item) {
    return (
      <Avatar
        style={{ width: 60, height: 60, borderRadius: 30 }}
        alt={item.name}
        src={item.avatar.url}
      />
    );
  }
  return (
    <Avatar
      style={{ width: 60, height: 60, borderRadius: 30 }}
      alt={item.name}
      src={defaultAvatar}
    />
  );
};

const getChatAvatar = function(item) {
  if ("avatar" in item) {
    return <Avatar src={item.avatar.url} style={{ marginRight: "10px" }} />;
  }
  return <Avatar src={defaultAvatar} style={{ marginRight: "10px" }} />;
};

export {
  getAvatar,
  getNormalAvatar,
  getSmallAvatar,
  getLargeAvatar,
  getChatAvatar
};
